import { useMemo } from 'react'
import cn from 'classnames'
import { subject } from '@casl/ability'
import { RowLayout } from '../../../../Vendors/VendorCreation/General/VendorForm/RowLayout'
import { FieldWithLabel } from '../../../../../../components/FieldWithLabel/FieldWithLabel'
import { Typography } from '../../../../../../components/Typography'
import { LinkHighlighter } from '../../../../../../components/LinkHighlighter/LinkHighlighter'
import {
  formatAddress,
  formatPhoneNumber
} from '../../../../../../helper/common'
import { LABELS } from '../../../../../../constants'
import {
  ability,
  ACTIONS,
  SUBJECTS,
  SubjectWithAttributes
} from 'features/Permission'
import { HealthSystemDetailsData } from '../types'

type GeneralDetailsProps = {
  data: HealthSystemDetailsData
}

export const GeneralDetails = ({ data }: GeneralDetailsProps) => {
  const canSeeLegalName = useMemo(
    () =>
      ability.can(
        ACTIONS.VIEW,
        subject(SUBJECTS.HEALTH_SYSTEM_LEGAL_NAME, {
          ...data
        } as unknown as SubjectWithAttributes)
      ),
    [data]
  )

  return (
    <>
      <RowLayout title="Business information">
        <div className={cn('row mt-12', { 'two-columns': canSeeLegalName })}>
          <FieldWithLabel
            className={cn({ 'half-width': canSeeLegalName })}
            title={
              canSeeLegalName
                ? LABELS.HS_NAME_DOING_BUSINESS_AS
                : LABELS.HEALTH_SYSTEM_NAME
            }
          >
            {data.name}
          </FieldWithLabel>
          {canSeeLegalName && (
            <FieldWithLabel title={LABELS.HS_LEGAL_NAME}>
              {data.legal_name ?? '-'}
            </FieldWithLabel>
          )}
        </div>
        <div className="row two-columns">
          <FieldWithLabel className="half-width" title={LABELS.WEBSITE}>
            {data.website ? <LinkHighlighter text={data.website} /> : '-'}
          </FieldWithLabel>
          <FieldWithLabel title={LABELS.PHONE_NUMBER}>
            {formatPhoneNumber(data.phone_number)}
          </FieldWithLabel>
        </div>
      </RowLayout>

      <div className="vendor-details-form__divider" />
      <RowLayout title="Address">
        <Typography.Body1>{formatAddress(data.address)}</Typography.Body1>
      </RowLayout>
    </>
  )
}
